import { Routes } from '@angular/router';

export const taxRoutes: Routes = [
  {
    path: 'taxation-profile',
    data: { moduleCode: 'tax_profile' },
    children: [
      { path: '', loadComponent: () => import('./taxation-profile/taxation-profile').then((m) => m.TaxationProfile) },
      {
        path: 'details/:id',
        loadComponent: () => import('./taxation-profile/taxation-details/taxation-details').then((m) => m.TaxationDetails)
      }
      //   { path: 'import', component: AssetTypeImport }
    ]
  },
  {
    path: 'tax-summary',
    data: { moduleCode: 'tax_summary' },
    children: [{ path: '', loadComponent: () => import('./tax-summary/tax-summary').then((m) => m.TaxSummary) }]
  },
  {
    path: 'tax-details',
    data: { moduleCode: 'tax_details' },
    children: [{ path: '', loadComponent: () => import('./tax-details/tax-details').then((m) => m.TaxDetails) }]
  },
  {
    path: 'taxation-update',
    data: { moduleCode: 'tax_update' },
    children: [
      { path: '', loadComponent: () => import('./update-taxation-req/update-taxation-req').then((m) => m.UpdateTaxationReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./update-taxation-req/update-taxation-req-details/update-taxation-req-details').then((m) => m.UpdateTaxationReqDetails),
        data: { reqModuleType: 'approver' }
      }
    ]
  },
  {
    path: 'hs-code',
    data: { moduleCode: 'tax_hscode' },
    children: [
      { path: '', loadComponent: () => import('./hs-code/hs-code').then((m) => m.HSCode) },
      { path: 'add', loadComponent: () => import('./hs-code/hs-code-details/hs-code-details').then((m) => m.HSCodeDetails) },
      { path: 'details/:id', loadComponent: () => import('./hs-code/hs-code-details/hs-code-details').then((m) => m.HSCodeDetails) },
      { path: 'import', loadComponent: () => import('./hs-code/hs-code-import/hs-code-import').then((m) => m.HSCodeImport) }
    ]
  }
];
